export const frontmatter = {
    "draft": true,
    "title": "Auditoría de seguridad",
    "description": "Registro de eventos de seguridad y acceso en OnnIA.",
    "sidebar_label": "Auditoría de seguridad",
    "sidebar_group": "referencia",
    "sidebar_order": 7
}

export const toc = []